import { render, staticRenderFns } from "./Waca.vue?vue&type=template&id=71538617&"
import script from "./Waca.vue?vue&type=script&lang=js&"
export * from "./Waca.vue?vue&type=script&lang=js&"
import style0 from "./Waca.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports